import Service from "../../Services/index";

const Status = {
    namespaced: true,
    state: {
        order_status: [],
        invoice_status: [],
        shift_work : [],
        shift_work_employee : [],
        province : [],
        districts:[],
        sub_districts :[],
        geography:[],
        position:[],
        employee_type:[],
        rate_bonus:[],
        material_type : [],
        size_product : [],
        bank_type : [],
        passport_type : [],
    },
    mutations: {
        GET_ORDER_STATUS: (state, data) => {
            state.order_status = data;
        },
        GET_INVOICE_STATUS: (state, data) => {
            state.invoice_status = data;
        },
        GET_SHIFT_WORK:(state,data)=>{
            state.shift_work = data;
        },
        GET_PROVINCE:(state,data)=>{
            state.province = data;
        },
        GET_DISTRICTS:(state,data)=>{
            state.districts = data;
        },
        GET_SUB_DISTRICTS:(state,data)=>{
            state.sub_districts = data;
        },
        GET_GEOGRAPHY:(state,data)=>{
            state.geography = data;
        },
        GET_POSITION:(state,data)=>{
            state.position = data;
        },
        GET_EMPLOYEE_TYPE:(state,data)=>{
            state.employee_type = data;
        },
        GET_SHIFT_WORK_EMPLOYEE:(state,data)=>{
            state.shift_work_employee = data;
        },
        GET_RATE_BONUS_SALE:(state,data)=>{
            state.rate_bonus = data;
        },
        GET_MATERIAL_TYPE:(state,data)=>{
            state.material_type = data;
        },
        GET_SIZE_PRODUCT:(state,data)=>{
            state.size_product = data;
        },
        GET_BANK_TYPE :(state,data)=>{
            state.bank_type = data;
        },
        GET_PASSPORT_TYPE :(state,data)=>{
            state.passport_type = data;
        }
    },
    actions: {
        setOrderStatus({ commit }) {
            return Service.Common.getOrderStatus()
                .then(response => {
                    commit("GET_ORDER_STATUS", response);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        setPosition({commit}){
            return Service.Common.getPosition()
                .then(response=>{
                    commit("GET_POSITION", response);
                })
        },
        setEmployeeType({commit}){
            return Service.Common.getEmployeeType()
                .then(response=>{
                    commit("GET_EMPLOYEE_TYPE", response);
                })
        },
        setInvoiceStatus({ commit }) {
            return Service.Common.getInvoiceStatus()
                .then(response => {
                    commit("GET_INVOICE_STATUS", response);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        setShiftWork({commit}){
            return Service.Common.getShiftWork()
                .then(response => {
                    commit("GET_SHIFT_WORK", response);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        setProvince({commit}){
            return Service.Common.getProvince()
                .then(data=>{
                    commit("GET_PROVINCE",data);
                })
        },
        setDistrict({commit},province_code){
            return Service.Common.searchDistricts(province_code)
                .then(data=>{
                    commit("GET_DISTRICTS",data);
                })
        },
        setSubDistrict({commit},district_code){
            return Service.Common.searchSubDistricts(district_code)
                .then(data=>{
                    commit("GET_SUB_DISTRICTS",data);
                })
        },
        setGeography({commit}){
            return Service.Common.getGeography()
                .then(res=>{
                    commit("GET_GEOGRAPHY" ,res)
                })
        },
        setProvinceFromGeography({commit},area){
            return Service.Common.getProvinceFromGeography(area)
                .then(res=>{
                    commit("GET_PROVINCE" ,res);
                })
        },
        setShiftWorkEmployee({commit}){
            return Service.Common.getShiftWorkEmployee()
                .then(res=>{
                    commit("GET_SHIFT_WORK_EMPLOYEE" ,res);
                })
        },
        setRateBonusSaleAll({commit}){
            return Service.Common.getRateBonusSaleAll()
                .then(res=>{
                    commit("GET_RATE_BONUS_SALE" ,res);
                })
        },
        getMaterialType({commit}){
            return Service.Common.getMaterialType().then(res=>{
                commit("GET_MATERIAL_TYPE",res)
            })
        },
        getSizeWrapProduct({commit}){
            return Service.Common.getSizeWrapProduct().then(res=>{
                commit("GET_SIZE_PRODUCT",res)
            })
        },
        getBankType({commit}){
            return Service.Common.getBankType().then(res=>{
                commit("GET_BANK_TYPE",res)
            })
        },
        getBankBranch({commit}){
            return Service.Common.getBankBranch();
        },
        getPassportType({commit}){
           return Service.Common.getPassportType().then(res=>{
               commit('GET_PASSPORT_TYPE',res);
           });
        },
        getWorkTime(){
            return Service.Common.getWorkTime();
        },
        getPathFile({commit},data){
            return Service.Common.uploadFile(data);
        },
        getRateTax({commit}){
            return Service.Common.getRateTax();
        }

    }
};

export default Status;
